// @flow
import styled from "styled-components";
import { ButtonLink } from "@nested/component-library";

import { media } from "../../media";
import { desktopImageSizing } from "./utils";

const H3 = styled.h3`
  color: white;
`;

const Slide = styled.div`
  overflow-x: hidden;
  position: relative;
  height: calc(100vw / (16 / 9));
  ${media.tablet`
    height: 400px;
  `};
  ${media.desktop`
    ${desktopImageSizing()}
  `};
  background-color: ${({ theme }) => theme.palette.hague};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  > * {
    margin: 10px;
  }
`;

const StyledP = styled.p`
  color: white;
  ${media.tablet`
    max-width: 70%;
    text-align: center;
  `};
`;

export const PropositionSlide = (props: Object) => (
  /*
   * we have to spread the props here so that the slider can control how it's displayed properly
   * our custom styles need to be in their own, nested div so that the slider can't interfere with them
   */
  <div {...props}>
    <Slide>
      <H3>Selling your home?</H3>
      <StyledP>
        Get the best result from your sale by combining the best of traditional
        agents with powerful technology.
      </StyledP>
      <ButtonLink type="accent" to="/">
        Find out more
      </ButtonLink>
    </Slide>
  </div>
);
